import { Outlet } from 'react-router-dom'
import { SiteHeader } from '@/components/site-header'
import { SiteFooter } from '@/components/site-footer'
import { AdminOverlayProvider } from '@/components/admin/admin-overlay-provider'
import { AuthOverlay } from '@/components/auth/auth-overlay'
import { CartDrawer } from '@/components/cart/cart-drawer'
import { useAuth } from '@/hooks/useAuth'

export function PublicLayout() {
  const { user, adminUser } = useAuth()

  return (
    <AdminOverlayProvider adminUser={adminUser}>
      <div className="flex flex-col min-h-screen">
        <SiteHeader />
        <AuthOverlay isAuthenticated={!!user} />
        <CartDrawer />
        <main className="flex flex-1 flex-col">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </AdminOverlayProvider>
  )
}
